import { createFileRoute, redirect } from "@tanstack/react-router";
import { resolveAuthenticatedLandingTarget } from "@/lib/auth-landing";
import { ForgotPasswordPage } from "@/pages/forgot-password.page";

export const Route = createFileRoute("/forgot-password")({
  beforeLoad: async ({ context }) => {
    if (context.auth.isAuthenticated) {
      const target = await resolveAuthenticatedLandingTarget(
        context.auth.user?.preferred_display_board ?? null,
      );
      throw redirect(target);
    }
  },
  component: ForgotPasswordPage,
});
